var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.section.type === 'hero')?_c('HomeHeroSection',{attrs:{"section":_vm.section}}):(_vm.isCarousel)?_c('ConfigurableCarousel',{attrs:{"section":_vm.section,"default-images":[],"variant":_vm.carouselVariant}}):_c('CommercialHomeSections',{attrs:{"sections":[_vm.section]}})
}
var staticRenderFns = []

export { render, staticRenderFns }